import React from 'react';
import FooterMenu from './FooterMenu';
import { useLocation } from 'react-router-dom';
const footerPages = ['/store', '/messages', '/menu', '/account'];
const FooterWrapper = () => {
  const location = useLocation();
  return (
    <>
      {footerPages.includes(location.pathname) && (
        <div className="pb-80">
          <FooterMenu />
        </div>
      )}
    </>
  );
};

export default FooterWrapper;
